import React, { Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import { Icon } from 'react-icons-kit';
import { mediaRecordOutline } from 'react-icons-kit/typicons/mediaRecordOutline';
import { plus } from 'react-icons-kit/typicons/plus';
import { starOutline } from 'react-icons-kit/typicons/starOutline';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Image from 'reusecore/src/elements/Image';
import Container from 'common/src/components/UI/Container';
import FeatureBlock from 'common/src/components/FeatureBlock';
import { chat as chatIcon } from '../../Fizz/Icons/chat';
import { realTime as realTimeIcon } from '../../Fizz/Icons/realTime';
import { analytics as analyticsIcon } from '../../Fizz/Icons/analytics';
import { customerSupport as customerSupportIcon } from '../../Fizz/Icons/customerSupport';
import { contentModeration as contentModerationIcon } from '../../Fizz/Icons/contentModeration';
import { sticker as stickerIcon } from '../../Fizz/Icons/sticker';

import { SectionHeader } from '../appClassic.style';
import SectionWrapper, { FeatureWrapper } from './features.style';
import Box from 'reusecore/src/elements/Box';
import Button from 'reusecore/src/elements/Button';

const getIcon = name => {
  switch (name) {
    case 'chat':
      return chatIcon;
    case 'realTime':
      return realTimeIcon;
    case 'analytics':
      return analyticsIcon;
    case 'customerSupport':
      return customerSupportIcon;
    case 'contentModeration':
      return contentModerationIcon;
    case 'sticker':
      return stickerIcon;
  }
};

const Features = ({ button }) => {
  const data = useStaticQuery(graphql`
    query {
      appClassicJson {
        features {
          slogan
          title
          items {
            id
            color
            iconName
            title
            description
          }
        }
      }
    }
  `);
  const { slogan, title, items } = data.appClassicJson.features;

  return (
    <SectionWrapper id="features_section">
      <Container>
        <SectionHeader>
          <Fade up>
            <Heading as="h5" content={slogan} />
            <Heading style={{ fontWeight: 400 }} content={title} />
          </Fade>
        </SectionHeader>
        <FeatureWrapper>
          {items.map(item => (
            <Fade up delay={100 * item.id} key={`feature-key${item.id}`}>
              <FeatureBlock
                style={{ '--color': `${item.color}` }}
                icon={
                  <Fragment>
                    <Icon className="plus" icon={plus} />
                    <Icon className="circle" icon={mediaRecordOutline} />
                    {/* {item.iconPath} */}
                    <Icon
                      icon={getIcon(item.iconName)}
                      className="main"
                      size={64}
                    />
                    {/* <Image src={item.icon.publicURL} alt={item.title} /> */}
                    <Icon className="star" icon={starOutline} />
                  </Fragment>
                }
                iconPosition="left"
                title={<Heading as="h3" content={item.title} />}
                description={<Text content={item.description} />}
              />
            </Fade>
          ))}
        </FeatureWrapper>
        <Fade up>
          <Box style={{ marginTop: '60px', textAlign: 'center' }}>
            <a href="/features">
              <Button {...button} style={{ fontWeight: '700' }} title="LEARN MORE" />
            </a>
          </Box>
        </Fade>
      </Container>
    </SectionWrapper>
  );
};

Features.defaultProps = {
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px',
  },
};

export default Features;
